import { DashboardGlobalFiltersState } from "src/core/dashboard/contexts/DashboardContext";
import { GetWidgetFiltersParam } from "src/core/dashboard/api/widget-data.api";
import { FilterByType } from "src/core/dashboard/api/dashboard.api";

import { dateTransformer } from "./dateTransformer";

/**
 * Helper util to generate the API request filter params based on UI's global filters
 */
const getWidgetFilterParams = (globalFilters: DashboardGlobalFiltersState): GetWidgetFiltersParam | null => {
  if (globalFilters.dateRangeOptions) {
    const params: GetWidgetFiltersParam = { dateRange: dateTransformer(globalFilters.dateRangeOptions) };

    if (globalFilters.filterByValue) {
      if (globalFilters.filterByType?.filterBy === FilterByType.Branch) {
        params.branch = globalFilters.filterByValue;
      }

      if (globalFilters.filterByType?.filterBy === FilterByType.Customer) {
        params.customer = globalFilters.filterByValue;
      }
    }

    return params;
  }

  return null;
};

export default getWidgetFilterParams;